export function prettyPrint(milli_cents)
{
    let dollar_part = Math.floor(milli_cents / 100000);
	let cents_part = Math.floor(milli_cents) % 100000;

    let ret = '$';
		
	ret += dollar_part.toLocaleString();
	ret += '.';

    let cent_part_str = (''+cents_part).padStart(5,'0');

    ret += cent_part_str.substring(0,2);
    ret += '_'
    ret += cent_part_str.substring(2,5);

	return ret;
}

export function prettyPrintMillipercent(milli_cents)
{
    let dollar_part = Math.floor(milli_cents / 1000);
	let cents_part = Math.floor(milli_cents) % 1000;

    let ret = '';
		
	ret += dollar_part.toLocaleString();
	ret += '.';

    let cent_part_str = (''+cents_part).padStart(3,'0');

    ret += cent_part_str;
    ret += '%';

	return ret;
}

export function prettyPrintDollars(milli_cents)
{
    if ( milli_cents == null ) return null;

    let dollar_part = Math.floor(milli_cents / 100000);
	let cents_part = Math.floor(milli_cents) % 100000;

    let ret = '$';
		
	ret += dollar_part.toLocaleString();
	ret += '.';

    let cent_part_str = (''+cents_part).padStart(5,'0');

    ret += cent_part_str.substring(0,2);

	return ret;
}

export function prettyPrintWholeDollars(milli_cents)
{
    if ( milli_cents == null ) return null;

    let dollar_part = Math.floor(milli_cents / 100000);

    let ret = '$';
	ret += dollar_part.toLocaleString();

	return ret;
}

export function prettyPrintWholeDollarsAccounting(milli_cents)
{
    if ( milli_cents == null ) 
        return null;

    let loss = milli_cents < 0;
    milli_cents = Math.abs(milli_cents);

    let dollar_part = Math.floor(milli_cents / 100000);

    let ret = '$';
    if ( loss )
        ret += ' (';

	ret += dollar_part.toLocaleString();

    if ( loss )
        ret += ')';

	return ret;
}

export default {
    prettyPrint,
    prettyPrintDollars,
    prettyPrintMillipercent,
    prettyPrintWholeDollars
};